import React from 'react'
import { useHistory } from 'react-router-dom'

export default function BackButton() {
  const history = useHistory()
  return (
    <div
      onClick={() => {
        history.goBack()
      }}
      style={{
        cursor: 'pointer',
        fontSize: 13,
        color: 'blue',
        marginBottom: 16,
      }}
    >
      {'< Go Back'}
    </div>
  )
}
